import { Worksheet } from "exceljs";
import i18n from "i18n";
import { WBSStore } from "modules/WBS/WBSStore";
import { WBSPropertiesStore } from "modules/WBS/WBSPropertiesStore";
import { EContentType } from "common/enums";
import { roundBy } from "utils/DecimalUtils";
import {
  borderThinStyle,
  fillGray03,
  fillLightGray,
  fontTitleHeader,
} from "./ReportStyles";

const ABC_COLOR = [
  { pMin: 0, pMax: 80, c: "ffff4500", toolbar: "Curva A - De 0% a 80%" },
  { pMin: 80, pMax: 95, c: "ffff8c00", toolbar: "Curva B - De 80,01% a 95%" },
  { pMin: 95, pMax: 101, c: "ffc0d147", toolbar: "Curva C - De 95,01% a 100%" },
];

const getDataGroupedResourcesSynthetic = async (
  worksheet: Worksheet,
  isType?: boolean,
  propertyKey?: string
) => {
  worksheet = setColumnHeader(worksheet);

  let formatedData: any = [];
  let { resourcesDataTable } = WBSStore;
  let contentType = "";

  for (let i = 0; i < resourcesDataTable.length; i++) {
    let e = resourcesDataTable[i];
    let customProperties = {};

    const equalRows = WBSStore.getListByContent(e.contentId, e.id);
    if (equalRows && equalRows.length)
      customProperties = equalRows[0].data.customProperties || {};

    // “labor” - Quando for mão de obra
    // “equipment” - Quando for equipamento
    // “material” - Quando for material
    // “other” - Quando for outro.
    if (
      e.contentType === EContentType.LABOR ||
      e.contentType === EContentType.EQUIPMENT ||
      e.contentType === EContentType.MATERIAL
    ) {
      contentType = i18n.project.rightSideMenu.categories[e.contentType];
    } else {
      contentType = i18n.project.rightSideMenu.categories.other;
    }

    formatedData.push({
      code: e.rowCode ? e.rowCode : "",
      description: e.description ? e.description : "",
      quantity: e.quantity ? e.quantity : 0,
      unit: e.unit ? e.unit : "",
      unitCost: isFinite(Number(e.unitCost))
        ? roundBy(Number(e.unitCost), WBSPropertiesStore.getRules(2))
        : 0,
      total_cost: isFinite(Number(e.total_cost)) ? Number(e.total_cost) : 0,
      category: contentType ? contentType : "",
      origin: e.origin ? e.origin : "",
      percentage: e.percentage ? e.percentage / 100 : 0,
      cumulative_percentage: e.cumulative_percentage
        ? e.cumulative_percentage / 100
        : 0,
      customProperties,
    });
  }

  let cpObject: any = [];

  if (isType) {
    for (let item of formatedData) {
      if (!cpObject.find((e) => e.description == item.category)) {
        cpObject.push({
          description: item.category,
          total: item.total_cost,
          percentage: item.percentage,
          cumulativePercentage: 0,
        });
      } else {
        cpObject.find((e) => e.description == item.category).total +=
          item.total_cost;
        cpObject.find((e) => e.description == item.category).percentage +=
          item.percentage;
      }
    }
  } else {
    for (let item of formatedData) {
      if (Object.keys(item.customProperties).length > 0) {
        for (let key of Object.keys(item.customProperties)) {
          if (key == propertyKey) {
            if (
              !cpObject.find((e) => e.description == item.customProperties[key])
            ) {
              cpObject.push({
                description: item.customProperties[key],
                total: item.total_cost,
                percentage: item.percentage,
                cumulativePercentage: 0,
              });
            } else {
              cpObject.find(
                (e) => e.description == item.customProperties[key]
              ).total += item.total_cost;
              cpObject.find(
                (e) => e.description == item.customProperties[key]
              ).percentage += item.percentage;
            }
          }
        }
      }
    }
  }
  cpObject = cpObject.sort((a, b) => {
    if (a.total < b.total) {
      return 1;
    }
    if (a.total > b.total) {
      return -1;
    }
    return 0;
  });

  for (let i = 0; i < cpObject.length; i++) {
    if (i == 0) {
      cpObject[i].cumulativePercentage = cpObject[i].percentage;
    } else {
      cpObject[i].cumulativePercentage =
        cpObject[i].percentage + cpObject[i - 1].cumulativePercentage;
    }
  }

  let tmp: any = [];
  for (let i = 0; i < cpObject.length; i++) {
    tmp.push(cpObject[i]);
    if (i != cpObject.length - 1) {
      tmp.push({
        description: "",
        total: "",
        percentage: "",
        cumulativePercentage: "",
      });
    }
  }
  cpObject = tmp;

  for (let i = 0; i < cpObject.length; i++) {
    let color = "ff00ff00";
    let percentage = cpObject[i]["cumulativePercentage"] * 100;
    let tmpColor = ABC_COLOR.filter(
      (abc) => percentage > abc.pMin && percentage <= abc.pMax
    )[0];
    if (tmpColor != undefined) {
      color = tmpColor.c;
    }

    worksheet.getCell("A" + (i + 13)).value = cpObject[i]["description"];
    worksheet.getCell("H" + (i + 13)).value = cpObject[i]["total"];
    worksheet.getCell("K" + (i + 13)).value = cpObject[i]["percentage"];
    worksheet.getCell("L" + (i + 13)).value =
      cpObject[i]["cumulativePercentage"];
    worksheet.getCell("H" + (i + 13)).numFmt = '"R$ "#,##0.00';
    worksheet.getCell("K" + (i + 13)).numFmt = "0.00%";
    worksheet.getCell("L" + (i + 13)).numFmt = "0.00%";

    let array = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"];
    for (let j = 0; j < array.length; j++) {
      worksheet.getCell(array[j] + (i + 13)).font = fontTitleHeader;

      if (
        cpObject[i]["description"] == "" &&
        cpObject[i]["total"] == "" &&
        cpObject[i]["percentage"] == "" &&
        cpObject[i]["cumulativePercentage"] == ""
      ) {
        for (let j = 0; j < array.length; j++) {
          worksheet.getCell(array[j] + (i + 13)).fill = fillLightGray;
        }
        break;
      }
      worksheet.getCell(array[j] + (i + 13)).border = borderThinStyle;
      worksheet.getCell(array[j] + (i + 13)).fill = fillGray03;
      worksheet.getCell(array[j] + (i + 13)).alignment = { vertical: "middle" };
    }
  }

  return worksheet;
};

const setColumnHeader = (worksheet: Worksheet) => {
  worksheet.getCell("A12").value = i18n.resources.description;
  worksheet.getCell("H12").value = i18n.resources.total;
  worksheet.getCell("K12").value = "%";
  worksheet.getCell("L12").value = i18n.resources.cumulativePercentageSmall;

  return worksheet;
};

export default getDataGroupedResourcesSynthetic;



// WEBPACK FOOTER //
// ./src/modules/costPlan/assets/excelReports/groupedResourcesSynthetic.ts